// extracted by mini-css-extract-plugin
export default {"imageSwitcher":"ImageSwitcher_imageSwitcher__FbugV","image":"ImageSwitcher_image__NfxJU","arrow":"ImageSwitcher_arrow__ihVYw"};